import { PostMessage } from 'src/app/models/post-message.model';

export class PostMessageReceived {
  public static readonly type = '[PostMessage] Received';
  constructor(public payload: PostMessage) {}
}
